<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M12.9885 8.36369C13.1061 7.88293 13.1684 7.38051 13.1684 6.86353C13.1684 3.38842 10.3513 0.571289 6.87622 0.571289C3.40112 0.571289 0.583984 3.38842 0.583984 6.86353C0.583984 9.44465 2.1381 11.6627 4.36163 12.6332"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M0.583984 6.86328H13.1684"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.00604 9.76772C4.69213 8.83503 4.50452 7.85839 4.45312 6.86353C4.57201 4.56251 5.41954 2.35891 6.87322 0.571289C8.32691 2.35891 9.17444 4.56251 9.29332 6.86353C9.27237 7.269 9.22879 7.67144 9.16327 8.06911"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.8082 9.34619L15.4132 11.3414L10.8082 13.3367L6.20312 11.3414L10.8082 9.34619Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.29297 12.2515L8.29753 14.4224C8.29753 14.4224 9.05783 15.4285 10.8084 15.4285C12.5589 15.4285 13.3232 14.4224 13.3232 14.4224L13.3228 12.2515"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.20312 14.8511V11.3413"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
